export default __webpack_public_path__ + "static/media/social-media-whats-app.d5b59940.svg";